import Component from "../../lib/component";
import ComponentEvent from "../../lib/component_event";
import {fireElementEvent} from "../../helpers/event";

export const CollapsableFieldsetConfig = {
    componentTypeKey: 'CollapsableFieldset',
    baseHtmlClass: 'collapsable',
    selector: '.collapsable',

    errorHtmlClass: 'error',

    collapsedHtmlClassModifier: 'collapsed',
    openHtmlClassModifier: 'open',
    closedHtmlClassModifier: 'closed',
    errorHtmlClassModifier: 'hasError',

    openedEventName: 'Rankers.CollapsableFieldset:Opened',
    closedEventName: 'Rankers.CollapsableFieldset:Closed',
    toggledEventName: 'Rankers.CollapsableFieldset:Toggled',
};

export class CollapsableFieldset extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: CollapsableFieldsetConfig
        });

        this.formElement = this.element.closest('form');
        this.legendElement = this.element.querySelector('legend');
        this.inputItemElements = this.element.querySelectorAll('ol > li');

        this.isClosed = true;
        if (this.inputItemElementsHasError()) this.isClosed = false;
        if (this.hasHtmlClassState(CollapsableFieldsetConfig.openHtmlClassModifier)) this.isClosed = false;
        if (this.hasHtmlClassState(CollapsableFieldsetConfig.closedHtmlClassModifier)) this.isClosed = true;

        this.legendElement.addEventListener('click', this.handleLegendClick.bind(this));

        this.render();
    }

    handleLegendClick() {
        this.fireCollapsableFieldsetEvent(this.isClosed ? CollapsableFieldsetConfig.openedEventName : CollapsableFieldsetConfig.closedEventName);
        this.fireCollapsableFieldsetEvent(CollapsableFieldsetConfig.toggledEventName);
        this.isClosed = !this.isClosed;
        this.render();
    }

    fireCollapsableFieldsetEvent(eventName) {
        const componentEvent = new ComponentEvent(eventName, {target: this});
        this.fireEvent(componentEvent);
        fireElementEvent(this.element, eventName); // Also fire the event on the element.
    }

    render() {
        this.swapHtmlClassStates(this.isClosed, CollapsableFieldsetConfig.closedHtmlClassModifier, CollapsableFieldsetConfig.openHtmlClassModifier);
        this.conditionallySetHtmlClassState(this.inputItemElementsHasError(), CollapsableFieldsetConfig.errorHtmlClassModifier);
    }

    inputItemElementsHasError() {
        return [...this.inputItemElements].some((element)=>{ element.classList.contains(CollapsableFieldsetConfig.errorHtmlClass) });
    }
}

